export const ENDPOINT_GET_ACCOUNTS = '/account';
export const ENDPOINT_ADD_ACCOUNT = '/account';

export const ENDPOINT_GET_USER_INFO = '/account/';
export const ENDPOINT_ADD_CREDITS = '/account/add_credits';
export const ENDPOINT_REQUEST_LOGS_REPORT = '/account/request_logs_report';
export const ENDPOINT_REQUEST_LOGS_FILTER = '/account/request_logs';
